import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { connect } from 'react-redux'
import { getTaxons } from '../redux/actions/taxons'
import { getTranslations } from '../i18n'
import { findIfSlugExist, setFullLocale } from '../utils/utils'
import useShopStyles from '../components/Shop/Shop.style'
import Loader from '../components/Loader/Loader'
import SharedHead from '../components/Global/SharedHead'
import { createClient, getSingleDocument } from '../prismicio'
import { RootState } from '../redux/reducers/rootReducer'
import { PrismicGeneralConfig } from '../interfaces/common/prismicGeneralConfig'
import { InferGetStaticPropsType } from 'next/types'
import { GetMapDispatchTypes } from '../interfaces/common/redux'
import { prismicText } from '../components/Global/CMSText'

type Tprops = ReturnType<typeof mapStateToProps> &
  InferGetStaticPropsType<typeof getStaticProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const mapStateToProps = (state: RootState) => ({
  taxons: state.taxons,
})

const mapDispatchToProps = {
  getTaxons: getTaxons,
}

const Shop = ({ getTaxons, taxons, main }: Tprops) => {
  const LayoutStyle = {}
  const classes = useShopStyles(LayoutStyle)
  const router = useRouter()
  const redirectToShopPageFromHp = prismicText(
    main?.data?.redirect_to_shop_page_from_hp
  )
  const isRedirectToShopPageFromHp =
    redirectToShopPageFromHp && redirectToShopPageFromHp.length > 0

  useEffect(() => {
    if (!taxons || taxons?.items?.length === 0) {
      getTaxons()
    }
  }, [])

  useEffect(() => {
    if (
      taxons?.items?.length !== 0 &&
      router?.isReady &&
      !main?.data?.only_add_with_pack
    ) {
      if (isRedirectToShopPageFromHp) {
        router.push(`/${redirectToShopPageFromHp}`)
        return
      }
      // Root taxon (e.g. "tous-les-produits") holds every product, whereas the
      // first category can be out of stock. The catalog page only resolves the
      // root taxon by its code, so fall back to the first category otherwise.
      const rootTaxon = taxons?.items?.[0]
      const shopSlug =
        rootTaxon?.slug && findIfSlugExist(rootTaxon, [rootTaxon.slug])
          ? rootTaxon.slug
          : rootTaxon?.children?.[0]?.slug
      router.push(`/${shopSlug}`)
    }
  }, [taxons?.items, router])

  useEffect(() => {
    if (main?.data?.only_add_with_pack) {
      router.replace('/packs')
    }
  }, [])

  return (
    <>
      <SharedHead datas={main} />
      <div className={classes.loader}>
        <Loader />
      </div>
    </>
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const general: PrismicGeneralConfig | null = await getSingleDocument(
    client,
    lang,
    'general'
  )

  return {
    props: {
      main: general,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Shop)
